const messagesUrl = clientId => `/messages?client=${clientId}`;
const progressGraphUrl = (clientId, graphId) =>
  `/clients/${clientId}?tab=progress#${graphId}`;
const nutritionHistoryUrl = clientId =>
  `/clients/${clientId}/nutrition-history`;
const workoutHistoryUrl = clientId => `/clients/${clientId}/workout-history`;
const prgressPhotosUrl = clientId => `/clients/${clientId}/progress-photos`;
const addGoalUrl = clientId => `/clients/${clientId}/goals/new`;

export const NOTIFICATIONS_REDIRECT_URL = {
  'not-logs-pre-transformation-meal': messagesUrl,
  'not-logs-meal': messagesUrl,
  'logs-water': clientId => progressGraphUrl(clientId, 'water'),
  'logs-workout-solo': clientId => progressGraphUrl(clientId, 'exercise'),
  'logs-workout-group': clientId => progressGraphUrl(clientId, 'exercise'),
  'logs-digestion': clientId => progressGraphUrl(clientId, 'digestion'),
  'logs-craving': clientId => progressGraphUrl(clientId, 'craving'),
  'logs-hunger': clientId => progressGraphUrl(clientId, 'hunger'),
  'logs-energy': clientId => progressGraphUrl(clientId, 'energy'),
  'logs-sleep': clientId => progressGraphUrl(clientId, 'sleep'),
  'logs-weight': clientId => progressGraphUrl(clientId, 'weight'),
  'logs-steps': clientId => progressGraphUrl(clientId, 'steps'),
  'logs-resting-heart-rate': clientId =>
    progressGraphUrl(clientId, 'resting_heart_rate'),
  'logs-blood-pressure': clientId =>
    progressGraphUrl(clientId, 'blood_pressure'),
  'logs-adherence': clientId => progressGraphUrl(clientId, 'adherence'),
  'logs-meal-plan': nutritionHistoryUrl,
  'logs-workout-workout': workoutHistoryUrl,
  'add-progress-images': prgressPhotosUrl,
  'achieved-performance-type-goal': addGoalUrl,
  'calories-goal-exceeded': nutritionHistoryUrl,
  'carbs-goal-exceeded': nutritionHistoryUrl,
  'fat-goal-exceeded': nutritionHistoryUrl,
  'protein-goal-exceeded': nutritionHistoryUrl
};

export const ADD_PROGRESS_IMAGES_NOTIFICATION_TYPE = 'add-progress-images';
export const LOGS_PRE_TRANSFORMATION_NOTIFICATION_TYPE_PREFIX =
  'logs-pre-transformation';

export const NOTIFICATIONS_ASSIGNER_TYPES = {
  TRAINER: 'trainer',
  CLIENT: 'client'
};

export const NOTIFICATIONS_LIMIT = 30;
